/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboBranchConfigBadRequestResponse,
  BboBranchConfigFailureResponseResponse,
  BboBranchConfigForbiddenResponse,
  BboBranchConfigUnauthorizedResponse,
  PouchTypeResponseResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * @summary Gets pouch type from a barcode and validate that the checksum of the barcode is valid
 */
export const getPouchType = (barcode: string, signal?: AbortSignal) => {
  return customInstance<PouchTypeResponseResponse>({
    url: `/BboBranchConfigService/v1/pouch-type/${barcode}`,
    method: 'get',
    signal,
  });
};

export const getGetPouchTypeQueryKey = (barcode: string) => {
  return [`/BboBranchConfigService/v1/pouch-type/${barcode}`] as const;
};

export const getGetPouchTypeQueryOptions = <
  TData = Awaited<ReturnType<typeof getPouchType>>,
  TError = ErrorType<
    | BboBranchConfigBadRequestResponse
    | BboBranchConfigUnauthorizedResponse
    | BboBranchConfigForbiddenResponse
    | BboBranchConfigFailureResponseResponse
  >,
>(
  barcode: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPouchType>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPouchTypeQueryKey(barcode);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPouchType>>> = ({ signal }) =>
    getPouchType(barcode, signal);

  return { queryKey, queryFn, enabled: !!barcode, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPouchType>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPouchTypeQueryResult = NonNullable<Awaited<ReturnType<typeof getPouchType>>>;
export type GetPouchTypeQueryError = ErrorType<
  | BboBranchConfigBadRequestResponse
  | BboBranchConfigUnauthorizedResponse
  | BboBranchConfigForbiddenResponse
  | BboBranchConfigFailureResponseResponse
>;

/**
 * @summary Gets pouch type from a barcode and validate that the checksum of the barcode is valid
 */
export const useGetPouchType = <
  TData = Awaited<ReturnType<typeof getPouchType>>,
  TError = ErrorType<
    | BboBranchConfigBadRequestResponse
    | BboBranchConfigUnauthorizedResponse
    | BboBranchConfigForbiddenResponse
    | BboBranchConfigFailureResponseResponse
  >,
>(
  barcode: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPouchType>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetPouchTypeQueryOptions(barcode, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
